import React from "react";
import { Route } from "react-router-dom";
import AdminRoute from "./admin";
import ApprovalRoute from "./approval";
import DownloadRoute from "./download";

export default function UserRoutes( props ) {
    return (
    <Route path="/user">
       {AdminRoute(props)}
       {ApprovalRoute(props)}
       {DownloadRoute(props)}
    </Route>
    )
}